var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"all":"unset","margin":"0","padding":"0"}},[(!_vm.$store.state.global_spinner)?[_c('router-view')]:[_c('loader-spinner')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }